/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeizableIncomeExplanationLineResponse } from './SeizableIncomeExplanationLineResponse';
import {
    SeizableIncomeExplanationLineResponseFromJSON,
    SeizableIncomeExplanationLineResponseFromJSONTyped,
    SeizableIncomeExplanationLineResponseToJSON,
    SeizableIncomeExplanationLineResponseToJSONTyped,
} from './SeizableIncomeExplanationLineResponse';

/**
 * 
 * @export
 * @interface SeizableIncomeAssessmentResponse
 */
export interface SeizableIncomeAssessmentResponse {
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    income12: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    income14: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    nonSeizableIncome: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    totalIncome: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    maintenanceObligationCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeizableIncomeAssessmentResponse
     */
    isCalculated: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    seizableAmount12: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    seizableAmount14: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    remainingIncome: number;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    subsistenceAmount12: number | null;
    /**
     * 
     * @type {number}
     * @memberof SeizableIncomeAssessmentResponse
     */
    subsistenceAmount14: number | null;
    /**
     * 
     * @type {Array<SeizableIncomeExplanationLineResponse>}
     * @memberof SeizableIncomeAssessmentResponse
     */
    explanation: Array<SeizableIncomeExplanationLineResponse>;
}

/**
 * Check if a given object implements the SeizableIncomeAssessmentResponse interface.
 */
export function instanceOfSeizableIncomeAssessmentResponse(value: object): value is SeizableIncomeAssessmentResponse {
    if (!('income12' in value) || value['income12'] === undefined) return false;
    if (!('income14' in value) || value['income14'] === undefined) return false;
    if (!('nonSeizableIncome' in value) || value['nonSeizableIncome'] === undefined) return false;
    if (!('totalIncome' in value) || value['totalIncome'] === undefined) return false;
    if (!('maintenanceObligationCount' in value) || value['maintenanceObligationCount'] === undefined) return false;
    if (!('isCalculated' in value) || value['isCalculated'] === undefined) return false;
    if (!('seizableAmount12' in value) || value['seizableAmount12'] === undefined) return false;
    if (!('seizableAmount14' in value) || value['seizableAmount14'] === undefined) return false;
    if (!('remainingIncome' in value) || value['remainingIncome'] === undefined) return false;
    if (!('subsistenceAmount12' in value) || value['subsistenceAmount12'] === undefined) return false;
    if (!('subsistenceAmount14' in value) || value['subsistenceAmount14'] === undefined) return false;
    if (!('explanation' in value) || value['explanation'] === undefined) return false;
    return true;
}

export function SeizableIncomeAssessmentResponseFromJSON(json: any): SeizableIncomeAssessmentResponse {
    return SeizableIncomeAssessmentResponseFromJSONTyped(json, false);
}

export function SeizableIncomeAssessmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeizableIncomeAssessmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'income12': json['income12'],
        'income14': json['income14'],
        'nonSeizableIncome': json['nonSeizableIncome'],
        'totalIncome': json['totalIncome'],
        'maintenanceObligationCount': json['maintenanceObligationCount'],
        'isCalculated': json['isCalculated'],
        'seizableAmount12': json['seizableAmount12'],
        'seizableAmount14': json['seizableAmount14'],
        'remainingIncome': json['remainingIncome'],
        'subsistenceAmount12': json['subsistenceAmount12'],
        'subsistenceAmount14': json['subsistenceAmount14'],
        'explanation': ((json['explanation'] as Array<any>).map(SeizableIncomeExplanationLineResponseFromJSON)),
    };
}

export function SeizableIncomeAssessmentResponseToJSON(json: any): SeizableIncomeAssessmentResponse {
    return SeizableIncomeAssessmentResponseToJSONTyped(json, false);
}

export function SeizableIncomeAssessmentResponseToJSONTyped(value?: SeizableIncomeAssessmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'income12': value['income12'],
        'income14': value['income14'],
        'nonSeizableIncome': value['nonSeizableIncome'],
        'totalIncome': value['totalIncome'],
        'maintenanceObligationCount': value['maintenanceObligationCount'],
        'isCalculated': value['isCalculated'],
        'seizableAmount12': value['seizableAmount12'],
        'seizableAmount14': value['seizableAmount14'],
        'remainingIncome': value['remainingIncome'],
        'subsistenceAmount12': value['subsistenceAmount12'],
        'subsistenceAmount14': value['subsistenceAmount14'],
        'explanation': ((value['explanation'] as Array<any>).map(SeizableIncomeExplanationLineResponseToJSON)),
    };
}

